<template>
    <div class="profile">
        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed :text="spinnerText"></spinner>
        <div class="tabs-content">
            <div class="container">
                <h3 class="heading">
<!--                    <img src="../assets/life_pink.svg" alt="LIFE CONTENTS" title="Life Contents">-->
                    <svg width="34px" height="47px" viewBox="0 0 34 47" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: Sketch 44.1 (41455) - http://www.bohemiancoding.com/sketch -->
                        <title>Page 1</title>
                        <desc>Created with Sketch.</desc>
                        <defs></defs>
                        <g id="Group-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="01_Tone_Home_Unauthenticated" transform="translate(-125.000000, -1270.000000)" :fill="getCorpHeaderColor">
                                <path d="M131.268161,1315.78641 C130.977535,1315.78641 130.686929,1315.70766 130.426289,1315.54453 C129.798161,1315.15078 129.528161,1314.37453 129.775649,1313.67517 L136.398209,1294.97773 L127.583969,1294.97586 C127.028993,1294.97586 126.513329,1294.68524 126.226481,1294.20709 C125.939604,1293.73084 125.924604,1293.1402 126.18523,1292.64896 L137.24011,1271.84 C137.515735,1271.32251 138.051982,1271 138.638878,1271 L153.378238,1271 C153.97075,1271 154.512622,1271.33 154.786366,1271.85498 C155.058242,1272.38187 155.015114,1273.01374 154.671991,1273.49749 L145.384951,1286.60725 L157.062391,1286.60725 C157.701751,1286.60725 158.277367,1286.99162 158.524903,1287.58035 C158.770529,1288.17099 158.637406,1288.85158 158.187406,1289.30538 L132.393166,1315.31898 C132.08754,1315.62648 131.678782,1315.78585 131.268142,1315.78585 L131.268161,1315.78641 Z M130.218161,1291.80897 L138.638801,1291.80897 C139.152545,1291.80897 139.634417,1292.05834 139.932545,1292.47833 C140.228796,1292.89833 140.303796,1293.43646 140.131294,1293.9202 L135.121054,1308.0706 L153.261694,1289.77444 L142.322974,1289.77444 C141.730462,1289.77444 141.18859,1289.44444 140.916718,1288.91755 C140.644841,1288.39252 140.687969,1287.75878 141.031092,1287.27503 L150.316212,1274.16527 L139.591092,1274.16527 L130.218161,1291.80897 Z" id="Page-1" stroke="#FFFFFF" stroke-width="0.5"></path>
                                <g id="Group-7-Copy" transform="translate(126.000000, 1315.000000)" font-size="30" font-family="Quicksand-Regular, Quicksand" line-spacing="60" font-weight="normal">
                                    <text id="Inspiration">
                                        <tspan x="0" y="28">Inspiration</tspan>
                                    </text>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <br/><span v-bind:style="{ color: getCorpHeadingColor}">Life</span>
                </h3>
            </div>
            <div class="container-fluid">
                <div class="row" v-if="getVideoSubcategories">
                    <div class="col-md-12">
                        <div class="interest-container work">
                            <button-group v-model="interestIndexes">
                                <checkbox class="min-padding checkbox-btn"  v-for="(interest, interestSubCategoryId) in getVideoSubcategories" :key="interest.interestSubCategoryName.toString().toUpperCase()" :true-value="interest.interestSubCategoryName.toString().toUpperCase()" v-bind:style="styleInterestObject(interest.interestSubCategoryName.toString().toUpperCase())">
                                    {{interest.interestSubCategoryName}}
                                </checkbox>
                            </button-group>

                        </div>
                    </div>
                    <a v-a11y-action href="javascript:" v-if="getAuthLifeVideos && getAuthLifeVideos.length >= 100 && !showAllVideosFlag"  @click="showAllVideos('top')" class="bolder hidemobile">choose a category or click to see more</a>
                </div>
                <div class="row">
                    <div class="container">
                        <div class="tabContent" id="tabs-1" :class="{ current: true }">
                            <div v-if="hideCompleteList() && !isMobile">
                                <div class="row yourFaves" v-if="getAuthLifeVideos">
                                    <div class="col-md-12">
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "(video, index) in getAuthLifeVideos" v-if="(index + 1) <=99">
                                        <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline" :class="{ 'private-contents': video.isPrivate === '1' }">
                                        
                                        <!-- <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title" />
                                        <p class="text-wrap-title cursor"  :title="video.title"> <i class="fa fa-play-circle-o"></i> {{video.title}}</p> -->
                                        
                                        <div class="image-container">
                                                <img class="jw-img-1" :src="video.image"  :alt="video.title" :title="video.title"/>
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(video.duration) }}</p>
                                        </div>
                                        <p class="text-wrap-title cursor"  :title="video.title"> <i aria-hidden="true" class="fa fa-play-circle-o"></i> {{video.title}}</p>
                                        <hr>
                                        </a>
                                        <div class="plusicon btn-group" >
                                            <button aria-label="Add video to a playlist" title="Add to Playlist" :id="video.mediaid" type="button" @click="showPlaylistMenu(video.mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                     width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                            </button>
                                            <ul class="hide">
                                                <li  v-if="getUserPlaylists">
                                                    <label>
                                                        <b> Add to ...</b>
                                                    </label>
                                                </li>
                                                <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                    <label class="notificationwithcheckboxes">
                                                        <input type="checkbox" :checked="verifyVideoExists(playlist, video)" @click="setPlaylistVideoStatus(video, playlist, verifyVideoExists(playlist, video)) "/> {{playlist.title}}
                                                        <transition name="fade">
                                                            <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                            <span class="added" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                        </transition>
                                                        <transition name="fade">
                                                            <span class="removed" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                        </transition>
                                                    </label>
                                                </li>
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Second option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Third option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Forth option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                <li><label style="color:#f0617d">Create new playlist</label></li>
                                                <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                </label> </li>
                                            </ul>
                                            <div class="backdropformenu"  @click="hidePlaylistMenu(video.mediaid)"></div>
                                        </div>
                                        <p class="right-heart-icon">
                                            <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(video)" title ="Liked this video?">
                                                <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                   v-bind:class="{'activeIcons': getVideoStatus(video)}" aria-hidden="true" ></i></a>
                                        </p>
                                    </div>
                                    <a v-a11y-action id="btmLink" href="javascript:" v-if="getAuthLifeVideos && getAuthLifeVideos.length >= 100 && !showAllVideosFlag"  class="bolder hidemobile" @click="showAllVideos()">click to browse all videos</a>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row yourFaves" v-if="getAuthLifeVideos">
                                    <div class="col-md-12">
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "video in getAuthLifeVideos">
                                        <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline" :class="{ 'private-contents': video.isPrivate === '1' }">
                                        <!-- <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title" /> -->
                                        <div class="image-container">
                                                <img class="jw-img-1" :src="video.image"  :alt="video.title" :title="video.title"/>
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(video.duration) }}</p>
                                        </div>
                                        <p class="text-wrap-title cursor"  :title="video.title"> <i aria-hidden="true" class="fa fa-play-circle-o"></i> {{video.title}}</p>
                                        </a>
                                        <hr>
                                        <div class="plusicon btn-group">
                                            <button aria-label="Add video to a playlist" title="Add to Playlist" :id="video.mediaid" type="button" @click="showPlaylistMenu(video.mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="PLAYLIST" title="Playlist"/>-->
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                     width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                            </button>
                                            <ul class="hide">
                                                <li  v-if="getUserPlaylists">
                                                    <label>
                                                        <b> Add to ...</b>
                                                    </label>
                                                </li>
                                                <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                    <label class="notificationwithcheckboxes">
                                                        <input type="checkbox" :checked="verifyVideoExists(playlist, video)" @click="setPlaylistVideoStatus(video, playlist, verifyVideoExists(playlist, video)) "/> {{playlist.title}}
                                                        <transition name="fade">
                                                            <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                            <span class="added" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                        </transition>
                                                        <transition name="fade">
                                                            <span class="removed" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                        </transition>
                                                    </label>
                                                </li>
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Second option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Third option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Forth option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                <li><label style="color:#f0617d">Create new playlist</label></li>
                                                <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                </label> </li>
                                            </ul>
                                            <div class="backdropformenu"  @click="hidePlaylistMenu(video.mediaid)"></div>
                                        </div>
                                        <p class="right-heart-icon">
                                            <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(video)" title ="Liked this video?">
                                                <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                   v-bind:class="{'activeIcons': getVideoStatus(video)}" aria-hidden="true" ></i></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import { buttonGroup } from 'vue-strap'
    import spinner from '@/accessibility/Spinner'
    import input from '@/accessibility/Input'
    import checkbox from '@/accessibility/Checkbox'
    import $ from 'jquery'
    export default {
        spinner: false,
        components: {
            'bs-input': input,
            'checkbox': checkbox,
            'button-group': buttonGroup,
            'spinner': spinner,
            alert
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        name: 'profile',
        data: function () {
            return {
                metaTag_pageTitle: '',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: '',
                interestIndexes: [],
                toggleSpinner: false,
                spinnerText: 'fetching videos',
                spinner: false,
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                firstVideoObject: '',
                showAllVideosFlag: false,
                isMobile: false,
                tabs: {
                    videos: true,
                    chat: false,
                    discussion: false
                }
            }
        },
        watch: {
            'interestIndexes' (to, from) {
                let self = this
                self.spinnerText = 'fetching videos'
                self.toggleSpinner = true
                self.showAllVideosFlag = false
                let corpId = 0
                if (self.user.corporation && this.user.corporation.corporationId > 0) {
                    corpId = this.user.corporation.corporationId
                }
                if (self.interestIndexes && self.interestIndexes.length > 0) {
                    // following 4 line are for enabling toggle (single selection) feature
                    let tmpInterest = self.interestIndexes[self.interestIndexes.length - 1]
                    console.log('category selected : tmpInterest = ', tmpInterest)
                    self.interestIndexes.length = 0
                    self.interestIndexes[0] = tmpInterest
                    console.log('category selected', self.interestIndexes)
                    let payload = {
                        corpId: corpId,
                        lstInterestSubCategoryName: self.interestIndexes
                    }
                    self.$store.dispatch('GETFILTEREDLIFEVIDEOS', {payload: payload}).then(() => {
                        console.log('Results', self.getAuthLifeVideos.length)
                        self.toggleSpinner = false
                    })
                } else {
                    let corpId = 0
                    if (self.user.corporation && this.user.corporation.corporationId > 0) {
                        corpId = this.user.corporation.corporationId
                    }
                    let params = ['LIFE', corpId]
                    self.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                        if (self.getAuthLifeVideos) {
                            self.toggleSpinner = false
                        }
                    })
                }
            }
        },
        methods: {
            formattedDuration (duration) {
                const hours = Math.floor(duration / 3600)
                const minutes = Math.floor((duration % 3600) / 60)
                const seconds = duration % 60
                const formattedHours = hours > 0 ? `${hours}:` : ''
                const formattedMinutes = minutes > 0 ? `${minutes}:` : '0:'
                const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
                return `${formattedHours}${formattedMinutes}${formattedSeconds}`
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            styleInterestObject (interestId) {
                // console.log('interestId', interestId)
                // console.log('all indexes', this.interestIndexes)
                let isSelected = this.interestIndexes.filter(x => {
                    return x.toString() === interestId.toString()
                })
                if (isSelected && isSelected.length > 0) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // border: '2px solid' + this.getCorpButtonColor + ' !important'
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                    }
                }
            },
            showAllVideos (ref) {
                if (ref === 'top') {
                    setTimeout(() => {
                        $('html,body').animate({ scrollTop: $('#btmLink').offset().top }, 800)
                        this.toggleSpinner = true
                        this.showAllVideosFlag = true
                        setTimeout(() => {
                            this.toggleSpinner = false
                        }, 700)
                    }, 800)
                } else {
                    this.toggleSpinner = true
                    this.showAllVideosFlag = true
                    setTimeout(() => {
                        this.toggleSpinner = false
                    }, 700)
                }
            },
            hideCompleteList () {
                let self = this
                if (self.getAuthLifeVideos && self.getAuthLifeVideos.length <= 99 && !self.showAllVideosFlag) {
                    return true
                } else if (self.getAuthLifeVideos && self.getAuthLifeVideos.length > 99 && self.showAllVideosFlag) {
                    return false
                }
                return true
            },
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            setVideoPlayerObject (videoCode) {
                if (this.getTrialDays < 0) {
                    this.$router.push(`/becomemember`)
                } else {
                    this.$router.push(`/watch/${videoCode}`)
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        if (exists[0].liked === '1') {
                            exists[0].liked = '0'
                        } else {
                            exists[0].liked = '1'
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    } else {
                        let logWatchedEntry = {
                            videoCode: videoObject.mediaid,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '1',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    }
                }
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            }
        },
        computed: {
            ...mapGetters([
                'getAuthLifeVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getVideoSubcategories', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getAllSiteContents'
            ])
        },
        mounted () {
            let self = this
            self.$store.dispatch('GETDYNAMICCONTENTS', 28).then(() => {
                if (self.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
            let checkMobile = $(window).width()
            if (checkMobile < 767) {
                self.isMobile = true
            } else {
                self.isMobile = false
            }
            self.toggleSpinner = true
            let corpId = 0
            if (self.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
            }
            let params = ['LIFE', corpId]
            self.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                if (self.getAuthLifeVideos) {
                    self.firstVideoObject = self.getAuthLifeVideos[0]
                    self.$store.dispatch('CACHEPAGE', window.location.href)
                    self.toggleSpinner = false
                }
            })
            self.$store.dispatch('GETVIDEOSUBCATEGORIES', params).then(() => {
            })
            // Get User Liked Videos
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            // Get User Playlists
            this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
        }
    }
</script>
<style scoped>
    .text-wrap-title-1 {
        right: -14px;
        position: absolute;
        background-color: rgb(68, 189, 168) !important;
        color: #fff !important;
        font-size: 12px !important;
        padding: 2px 4px !important;
        border-top-left-radius: 4px !important;
        line-height: 1.1 !important;
    }
    .align-to-bottom {
        right: -13px !important;
        top: -9px !important;
    }

    .jw-img-1 {
        max-width: 100%; /* Ensure the image does not exceed its container width */
    }
    .image-container {
        position: relative;
        display: flex;
        justify-content: space-between;
    }
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
    .bolder {
        font-size: 18px;
        font-weight: 900;
    }
    @media(max-width:767px){
        .hidemobile{display:none;}
    }

</style>




// WEBPACK FOOTER //
// Life.vue?8f53814a